import { useEffect, useState } from 'react';
import '../../Settings/KanBan/kanban.css';
import {
  ChangeEventArgs,
  DropDownListComponent,
} from '@syncfusion/ej2-react-dropdowns';
import { changeReOrderFunc } from '../../../redux/search.slice';
import { useDispatch, useSelector } from 'react-redux';
function Reorder() {
  const dispatch = useDispatch();
  const slice = useSelector((state: any) => state.search);
  const dropdownData = [
    { text: 'False', value: false },
    { text: 'True', value: true },
  ];

  const valueChange = (args: ChangeEventArgs) => {
    dispatch(changeReOrderFunc(args.itemData.value));
  };
  return (
    <div>
      <div className='prioraty container'>
        <div className='eachHeader'>
          <span>Reorder Settings</span>
        </div>
        <div className='reorderflex'>
          <p className='reorderp'>Select Reorder Settings</p>
          <DropDownListComponent
            className='reordermargin'
            value={slice.reOrderAble ? 'True' : 'False'}
            width={150}
            dataSource={dropdownData}
            change={valueChange}
          ></DropDownListComponent>
        </div>
      </div>
    </div>
  );
}

export default Reorder;
